import React, { useEffect, useState } from "react"
import parse from "html-react-parser"
import { useMediaQuery, useTheme } from "@mui/material"

import * as S from "./about-us-letter.styles"
import { isBrowser } from "../../utils/utils"
import FormPopup from "../../components/form-popup/form-popup.component"

const AboutUsLetter = ({
  backgroundImage,
  letterImage,
  content,
  letterIcon,
  letterImageMobile,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <S.Section>
      <S.BackgroundImage img={backgroundImage}>
        <S.Wrapper>
          <S.GroupContainer>
            <S.LetterImage img={isMobile ? letterImageMobile : letterImage}>
              <S.Content>{parse(content)}</S.Content>
              <S.LetterIcon img={letterIcon} />
            </S.LetterImage>
          </S.GroupContainer>
        </S.Wrapper>
      </S.BackgroundImage>
    </S.Section>
  )
}

export default AboutUsLetter
